import React from 'react';

import { filterEmptyContent, hasNoContent } from '../utils';

import { StyledParagraph } from './BlockParagraphStyles';

/**
 * Renders a paragraph tag in rich text
 *
 * @param {React.ReactNode} children
 *
 * @returns {React.ReactElement}
 */
function BlockParagraph({ children }) {
  if (hasNoContent(children)) return null;

  //solution to use s
  const useBody2 = children[0]?.toString().startsWith('[body2]');
  const variant = useBody2 ? 'DS_copyBigBold' : 'DS_copyMediumRegular';

  if (useBody2) children[0] = children[0].replace(/\[body2]\s?/, '');

  return (
    <StyledParagraph variant={variant} component="p">
      {filterEmptyContent(children)}
    </StyledParagraph>
  );
}

export default BlockParagraph;
